import React from 'react';
import './Popup.css'; // Ensure this file contains your CSS for the popup

const Popup = ({ isVisible, title, onClose, onConfirm }) => {
  // If the popup should not be visible, return null to prevent it from rendering
  if (!isVisible) return null;

  return (
    <div className="popup">
      {/* Inner content of the popup, styled by the "popup-content" CSS class */}
      <div className="popup-content">
        {/* Display the title of the popup, passed as a prop */}
        <h2 className="popup-title">{title}</h2>
        {/* Static message prompting the user for confirmation */}
        <p className="popup-message">{'Are you sure you would like to skip the quiz? '}</p>
        {/* Container for the action buttons */}
        <div className="popup-buttons">
          {/* Close button, calls the onClose handler when clicked */}
          <button className="popup-button" onClick={onClose}>Close</button>
          {/* Conditionally render the Confirm button if the onConfirm prop is provided */}
          
          {onConfirm && <button className="popup-button" onClick={onConfirm}>Confirm</button>}
        </div>
      </div>
    </div>
  );
};

export default Popup;
